import { render, staticRenderFns } from "./LinkChip.vue?vue&type=template&id=4b70137b&"
import script from "./LinkChip.vue?vue&type=script&lang=ts&"
export * from "./LinkChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports